/* ==========================================================
   eup-collection-grid.js
   Shopifyテーマの「コードを編集」から追加するJSファイル。
   ブログ記事のHTML編集画面は保存時に<script>タグを削除してしまうため、
   記事本文には <div class="eup-collection-grid" data-collection-handle="..."> の
   マークアップだけを置き、実際にfetchして描画するこのロジックは
   テーマ側（サニタイズされない場所）に置く。

   設置手順:
   1. Shopify管理画面 > オンラインストア > テーマ > 「…」 > コードを編集
   2. 左メニュー Assets（アセット）で「新しいアセットを追加」
      → このファイルをアップロード（ファイル名: eup-collection-grid.js）
   3. Layout の theme.liquid を開き、</body> の直前に以下を追加:
        <script src="{{ 'eup-collection-grid.js' | asset_url }}" defer></script>
   4. ブログ記事本文（HTMLで編集）には、下記のようにdivだけを置く:
        <div class="eup-collection-grid eup-handle-2026summersale eup-max-8">
          <p class="eup-collection-loading">商品を読み込み中です…</p>
        </div>
      ※<script>は記事側には一切書かない

   コレクションのハンドル・最大表示件数の指定方法について:
   当初は data-collection-handle / data-max-items 属性で指定していましたが、
   Shopifyのブログ記事編集画面（HTMLで編集）は保存時に、独自のdata-*属性を
   自動的に削除してしまうことが分かりました（<script>が消えるのと同じ、
   編集画面側のサニタイズ仕様）。class属性はこれまで一度も削除されていない
   ため、handle・最大件数は class名 に埋め込む方式に変更しています。
     - コレクションのハンドル: class="eup-handle-{ハンドル名}"
     - 最大表示件数:           class="eup-max-{数字}"
   例: class="eup-collection-grid eup-handle-2026summersale eup-max-8"
   （後方互換のため data-collection-handle / data-max-items 属性が存在すれば
   そちらを優先して読み取りますが、記事側では基本的にclass名の方式を使う）

   表示件数について:
   Shopify公開APIが返す件数（＝実店舗ページに表示される件数）をそのまま
   全件表示します。管理画面上の登録商品数と、Online Storeチャネルに
   公開されている商品数は一致しないことがあります（下書き・非公開商品は
   公開APIに含まれないため、実店舗ページ自体にも表示されません）。

   UI再現について（参考: shophub-engager-selftraining / lp-practice）:
   公開JSON（products.json）から取得できる範囲でできるだけ近づけています。
   - SALEバッジ: compare_at_price（元価格）が現在価格より高い場合に表示
   - カラーバリエーション数: 商品オプションに「カラー/色/Color」を含む
     選択肢があれば「+N色」を表示（現在の画像以外の残り数）
   - レビュー星評価・「残りわずか」の在庫数表示は、公開JSONに該当データが
     含まれていないため再現していません（レビューアプリ側のAPI連携か、
     テーマの実セクションを直接埋め込む方式でないと再現不可）
   - 売り切れ（SOLD OUT）表示はあえて実装していません。このコレクションは
     オリジナル商品のベースとなるラインアップ紹介が目的で、在庫・購入可否の
     概念自体が存在しないため（ラクスルノベルティ等と同じ考え方）。

   価格表示について:
   バリアント配列の先頭ではなく、全バリアントの中の最安値を価格として
   表示します（Shopify標準のコレクションページと同じ「最安価格〜」方式）。
   参考: https://euphoria-shophub.com/collections/lp-practice のタイルに
   合わせ、複数バリアントがある商品は「¥1,650〜（税込）」の形式、
   単一バリアントの商品は「〜」を付けず「¥1,650（税込）」の形式にしています。

   表示件数の上限について:
   class="eup-max-{数字}" で1回に表示する最大件数を指定できます
   （未指定時は既定で8件）。実際の商品数がこれを超える場合は、
   グリッドの下に「すべて見る（◯件）」というボタンを自動で追加し、
   そのコレクションの実ページ（/collections/{handle}）に遷移します。

   デバッグログについて:
   冒頭の DEBUG を true にすると、ブラウザのConsoleに動作ログが出ます。
   本番公開時は false のままにしてください。
   ========================================================== */
(function () {
  // 動作確認用ログの出し分け。本番公開時はfalseのままにする。
  // 調査が必要になったら true に変更して再デプロイすれば、また
  // ブラウザのConsoleに [eup-collection-grid] のログが出るようになる。
  var DEBUG = false;

  function log() {
    if (DEBUG && window.console && console.log) console.log.apply(console, arguments);
  }

  function warn() {
    if (DEBUG && window.console && console.warn) console.warn.apply(console, arguments);
  }

  function logError() {
    if (DEBUG && window.console && console.error) console.error.apply(console, arguments);
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatPrice(price) {
    var n = Number(price);
    if (isNaN(n)) return '';
    return '¥' + n.toLocaleString('ja-JP');
  }

  // lp-practice の表示形式（例:「¥1,650〜（税込）」）に合わせる。
  // 複数バリアントがある商品のみ「〜」を付け、単一バリアントの商品には付けない。
  function formatPriceDisplay(price, hasMultipleVariants) {
    var formatted = formatPrice(price);
    if (!formatted) return '';
    return formatted + (hasMultipleVariants ? '〜（税込）' : '（税込）');
  }

  function getColorOptionCount(product) {
    var options = product.options || [];
    for (var i = 0; i < options.length; i++) {
      var name = String(options[i].name || '');
      if (/color|カラー|色/i.test(name)) {
        return (options[i].values || []).length;
      }
    }
    return 0;
  }

  // 配列の並び順に依存せず、最安値のバリアントを返す
  // （Shopify標準のコレクションページも「最安価格〜」で表示するため合わせる）
  function getMinPriceVariant(product) {
    var variants = product.variants || [];
    if (!variants.length) return {};
    return variants.reduce(function (min, v) {
      var vPrice = Number(v.price);
      var minPrice = Number(min.price);
      if (isNaN(minPrice) || (!isNaN(vPrice) && vPrice < minPrice)) return v;
      return min;
    }, variants[0]);
  }

  // data-*属性はShopifyの記事保存時に削除されることがあるため、
  // class名からも handle / maxItems を読み取れるようにする。
  // 例: class="eup-collection-grid eup-handle-2026summersale eup-max-8"
  // data-collection-handle / data-max-items が残っていればそちらを優先する。
  function parseGridConfig(grid) {
    var handle = grid.getAttribute('data-collection-handle') || null;
    var maxItemsAttr = grid.getAttribute('data-max-items');
    var maxItems = maxItemsAttr !== null ? parseInt(maxItemsAttr, 10) : null;

    var classes = (grid.className || '').split(/\s+/);
    classes.forEach(function (cls) {
      if (!handle && cls.indexOf('eup-handle-') === 0) {
        handle = cls.slice('eup-handle-'.length);
      }
      if ((maxItems === null || isNaN(maxItems)) && cls.indexOf('eup-max-') === 0) {
        var n = parseInt(cls.slice('eup-max-'.length), 10);
        if (!isNaN(n)) maxItems = n;
      }
    });

    if (maxItems === null || isNaN(maxItems) || maxItems < 0) maxItems = 8;
    return { handle: handle, maxItems: maxItems };
  }

  function renderGrid(container, handle, maxItems) {
    log('[eup-collection-grid] fetch開始:', '/collections/' + handle + '/products.json?limit=250');
    fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var allProducts = (data && data.products) || [];
        log('[eup-collection-grid] 取得商品数:', allProducts.length, 'handle:', handle, 'maxItems:', maxItems);
        if (!allProducts.length) {
          container.innerHTML = '<p class="eup-collection-empty">現在表示できる商品がありません。</p>';
          return;
        }

        var totalCount = allProducts.length;
        var products = maxItems > 0 ? allProducts.slice(0, maxItems) : allProducts;

        var html = products.map(function (p) {
          var img = (p.images && p.images[0] && p.images[0].src) || '';
          var variant = getMinPriceVariant(p); // 先頭固定ではなく最安バリアントを採用
          var hasMultipleVariants = (p.variants || []).length > 1;
          var priceRaw = formatPrice(variant.price);
          var compareAt = variant.compare_at_price ? formatPrice(variant.compare_at_price) : '';
          var priceDisplay = formatPriceDisplay(variant.price, hasMultipleVariants);
          var url = '/products/' + p.handle;
          var onSale = !!(compareAt && compareAt !== priceRaw);
          var colorCount = getColorOptionCount(p);

          // セール中のみ価格をアクセントカラーで強調。通常価格は基準の濃色テキストのまま
          // （参考ページには通常価格の強調表示がないため、それに合わせる）
          var priceHtml = onSale
            ? '<span class="eup-collection-price-current eup-collection-price-current--sale">' + priceDisplay + '</span>' +
              '<span class="eup-collection-price-compare">' + compareAt + '</span>'
            : '<span class="eup-collection-price-current">' + priceDisplay + '</span>';

          // 売り切れバッジは実装しない（このコレクションに在庫・購入可否の概念がないため）
          var badgesHtml = onSale
            ? '<span class="eup-collection-badge eup-collection-badge--sale">SALE</span>'
            : '';

          var colorHtml = colorCount > 1
            ? '<p class="eup-collection-card-color">+' + (colorCount - 1) + '色</p>'
            : '';

          return (
            '<a href="' + escapeHtml(url) + '" class="eup-collection-card">' +
              '<div class="eup-collection-card-img">' +
                (badgesHtml ? '<div class="eup-collection-badges">' + badgesHtml + '</div>' : '') +
                (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
              '</div>' +
              '<p class="eup-collection-card-title">' + escapeHtml(p.title) + '</p>' +
              colorHtml +
              '<p class="eup-collection-card-price">' + priceHtml + '</p>' +
            '</a>'
          );
        }).join('');

        container.innerHTML = html;

        // 表示件数が上限を超えている場合は「すべて見る」リンクをグリッドの下に追加
        var existingMore = container.parentNode ? container.parentNode.querySelector('.eup-collection-more[data-for="' + handle + '"]') : null;
        if (existingMore) existingMore.parentNode.removeChild(existingMore);

        if (maxItems > 0 && totalCount > maxItems) {
          var moreWrap = document.createElement('div');
          moreWrap.className = 'eup-collection-more';
          moreWrap.setAttribute('data-for', handle);
          // DETAILボタン（#455A64）と同じ見た目のボタンとして表示
          moreWrap.innerHTML =
            '<a href="/collections/' + escapeHtml(handle) + '" class="eup-btn eup-btn--detail">' +
              'すべて見る（' + totalCount + '件）' +
            '</a>';
          container.parentNode.insertBefore(moreWrap, container.nextSibling);
        }
      })
      .catch(function (err) {
        container.innerHTML = '<p class="eup-collection-empty">商品の読み込みに失敗しました。時間をおいて再度お試しください。</p>';
        logError('[eup-collection-grid]', err);
      });
  }

  function init() {
    log('[eup-collection-grid] init実行');
    var grids = document.querySelectorAll('.eup-collection-grid');
    log('[eup-collection-grid] .eup-collection-grid 要素数:', grids.length);
    grids.forEach(function (grid) {
      var config = parseGridConfig(grid);
      log('[eup-collection-grid] handle:', config.handle, 'maxItems:', config.maxItems);
      if (config.handle) {
        renderGrid(grid, config.handle, config.maxItems);
      } else {
        warn('[eup-collection-grid] コレクションのハンドルが見つかりません（class="eup-handle-xxx" が付いているか確認してください）');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();